const billObtainRouter = {
  path: '/billObtain',
  component: () => import('@/views/maintainFund/billObtain/index.vue'),
  redirect: '/billObtain/main',
  children: [
    {
      path: 'main',
      name: 'billObtain',
      component: () => import('@/views/maintainFund/billObtain/main.vue'),
      meta: {
        title: '电子票下载'
      }
    },
    {
      path: 'downloadInvoice',
      name: 'billObtain',
      component: () => import('@/views/maintainFund/billObtain/downloadInvoice.vue'),
      meta: {
        title: '电子票下载'
      }
    },
  ]
}

export default billObtainRouter
